import { Link } from "react-router-dom";
import { seoArticles } from "@/mocks/articles";

export default function ArticlesSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full text-xs font-semibold bg-accent-100 text-accent-700 mb-4 tracking-wide uppercase">
            SEO Resources
          </span>
          <h2 className="text-3xl md:text-4xl font-bold font-heading text-foreground-950 mb-3">
            <strong>ACbuyspreadsheet</strong> Guides &amp; Resources
          </h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">
            Explore our complete library of <strong>acbuyspreadsheet</strong> articles, tutorials, and buying guides. 
            Everything you need to master the spreadsheet buying system.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {seoArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              onClick={() => window.scrollTo(0, 0)}
              className="group flex flex-col rounded-xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[3/2] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full text-xs font-semibold bg-background-50/90 text-primary-700">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="px-5 py-5 flex flex-col flex-1">
                <div className="flex items-center gap-3 mb-2">
                  <span className="text-xs text-foreground-400">{article.readTime}</span>
                  <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                  <span className="text-xs text-foreground-400">June 2026</span>
                </div>
                <h3 className="text-base md:text-lg font-bold font-heading text-foreground-950 group-hover:text-primary-600 transition-colors mb-2 line-clamp-2 leading-snug">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 flex-1">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-1.5 mt-4 text-sm font-semibold text-primary-600 group-hover:text-primary-700 transition-colors">
                  Read Article
                  <i className="ri-arrow-right-line text-sm group-hover:translate-x-1 transition-transform"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10 md:mt-14">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full text-base font-bold bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-shopping-bag-line"></i>
            Start Shopping Now
          </a>
        </div>
      </div>
    </section>
  );
}